import { ApiService } from 'services';
import { detectLocale, getSupportedLanguages, getShortDictionary } from 'common/language/localeHelper';
import {
  getLanguages,
  getLanguage,
  getJurisdictions,
  GET_LANGUAGES_SUCCESS,
  GET_DEFAULT_LANGUAGE_SUCCESS
} from 'actions/app';

export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const CHANGE_LOCALE_MESSAGES = 'CHANGE_LOCALE_MESSAGES';

function change(locale) {
  return {
    type: CHANGE_LOCALE,
    locale
  };
}

function changeMessages(dictionary) {
  return {
    type: CHANGE_LOCALE_MESSAGES,
    messages: dictionary
  };
}

function changeLanguages(languages) {
  return {
    type: GET_LANGUAGES_SUCCESS,
    languages
  };
}

function receiveEnglish(messages) {
  return {
    type: GET_DEFAULT_LANGUAGE_SUCCESS,
    messages
  };
}

function getEnglishLanguage() {
  return (dispatch) => {
    const promise = () => ApiService
      .getLanguage('en')
      .then((response) => {
        dispatch(receiveEnglish(response.data));
      }).catch((error) => {
        if (error.response || (error.retries && error.retries > 1)) {
          if (!error.response && error.retries && error.retries > 1) {
            ApiService.addQueuedPromise(promise, error);
          }
        }
      });

    return promise();
  };
}

function changeLocaleShortDictionary(dictionary) {
  return (dispatch) => {
    dispatch(changeMessages(dictionary));
  };
}

export function changeLocale(locale, updateDictionary = true) {
  return async (dispatch) => {
    dispatch(change(locale));

    if (updateDictionary) {
      const localeMessages = await getShortDictionary(locale);
      dispatch(changeLocaleShortDictionary(localeMessages));
    }
  };
}

export function loadLanguages() {
  return async (dispatch) => {
    const supportedLanguages = await getSupportedLanguages();

    const locale = detectLocale(supportedLanguages);
    dispatch(changeLocale(locale));
    dispatch(changeLanguages(supportedLanguages));

    dispatch(getLanguages());
    dispatch(getJurisdictions());
    dispatch(getLanguage(locale));
    if (locale !== 'en') {
      dispatch(getEnglishLanguage());
    }
  };
}
